import type { JSX } from 'react'

export const Ghost404Icon = (): JSX.Element => (
  <use href='#ghost404' height='100%' width='100%' />
)
